import React, { Component } from "react";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import axios from "../../axios";
// import './Events.css';
import * as url from "../../utils/url";
import {
  eventActionRoles,
  rsvpRoles,
  createGroupMember,
  eventRoles,
  groupRsvp,
  groupRoles,
  checkValidityForAnonymousToggleCreate,
} from "../../utils/constants";
// import Select,{components} from 'react-select';
import Select from "react-select";
import {
  customSingleValue,
  customOptions,
  eventDetailsCss,
} from "./RsvpSelectOptions";
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { isMobile } from "../../utils/deviceInfo";
import { BiLogOut } from "react-icons/bi";
import Toggle from "react-toggle";

//  const rsvpWithIcons =  groupRsvp(isAnonymousVisible).map( e=> {
//         if(e.value==0){
//           e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
//           className="rsvp_role_select_options_img invited_icon" viewBox="0 0 16 16">
//           <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"/>
//           <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"/>
//         </svg>
//         } else if (e.value==1){
//           e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="rsvp_role_select_options_img join_icon"
//           viewBox="0 0 16 16">
//           <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
//           <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
//         </svg>

//         } else if(e.value==2){
//           e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
//           className="rsvp_role_select_options_img hearted_icon" viewBox="0 0 16 16">
//           <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
//         </svg>
//         } else if (e.value==3){
//           e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
//           className="rsvp_role_select_options_img exit_icon" viewBox="0 0 16 16">
//           <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
//         </svg>
//         }
//         return e
//   })

// const CustomOption = ({ children, ...props }) => {
//   return (
//     <components.Option {...props}>
//       {/* <img src={props.data.icon} className="rsvp_role_select_options_img"/> */}
//       {props.data.icon}
//       <span className="rsvp_role_select_options_txt" >{children}</span>
//     </components.Option>
//   );
// };

// const SingleValue = ({ children, ...props }) => {
//   return (
//     <components.SingleValue {...props}>
//       <span className="rsvp_role_select_options_component">
//       {/* <img src={props.data.icon} className="rsvp_role_select_options_img"/> */}
//       {props.data.icon}
//       <span className="rsvp_role_select_options_txt" >{children}</span>
//       </span>
//     </components.SingleValue>
//   );
// };

class AddToGroup extends Component {
  constructor(props) {
    super(props);
    const showAnonymous =
      props.user.profile && props.user.profile.organizationId.disableAnonymity
        ? checkValidityForAnonymousToggleCreate("groups",props.user.profile.organizationId.disableAnonymity) 
        : false;
    this.state = {
      curr_rsvp: null,
      groupType: this.props.groupType,
      group_status: null,
      isLeaveGroup: false,
      preventCreate: false,
      joinAnonymously: false,
      isAnonymousVisible: !showAnonymous,
    };
  }

  componentDidMount() {
    let { groupType, is_member} = this.props;
    let{isAnonymousVisible}=this.state
    // let res;
    let group_status;
    console.log("is_member----", is_member);
    if (is_member>0) {
      group_status =  groupRsvp(isAnonymousVisible).filter((e) => e.value == is_member)[0];
    } else {
      group_status =  groupRsvp(isAnonymousVisible).filter((e) => e.value == groupType)[0];
    }

    this.setState({
      group_status,
    });
  }

  handleJoinGroup = (status) => {
    let{isAnonymousVisible}=this.state
    // return
    if (status && status.value) {
      this.setState({ group_status: status, preventCreate: true });
      let date_joined = new Date();
      let role_type =
        this.props.item.groupOwner._id.toString() ==
        this.props.user.profile._id.toString()
          ? "Admin"
          : "Member";
      let anonymousMember = status.value === 4;
      let memberObj = createGroupMember(
        this.props.user.profile,
        this.props.user.profile,
        date_joined,
        role_type,
        anonymousMember
      );
      let group = { ...this.props.item, date_joined };
      let insert_grp = {
        createdOn: this.props.item.createdOn,
        date_joined: date_joined,
        invitedBy: this.props.user.profile._id,
        o_id: this.props.item._id,
        role:
        this.props.item.groupOwner && this.props.item.groupOwner._id == this.props.user.profile._id
            ? 0
            : 1000,
        orgId: this.props.item.organizationId,
      };
      let payload = {
        group,
        memberObj,
        insert_grp,
        action: status.value == 1 || status.value == 4 ? "join" : "leave",
        noLoader: true,
      };

      if (this.props.isSingleGrpMenu) {
        let role_type, group_status;
        if (payload.action == "leave") {
          role_type = -1;
          group_status =  groupRsvp(isAnonymousVisible).filter((e) => e.value == 0)[0];
        } else {
          role_type = groupRoles.filter((e) => e.role == "Member")[0].value;
          group_status =  groupRsvp(isAnonymousVisible).filter((e) => e.value == 1)[0];
        }
        console.log("role_type---", role_type);
        // this.setState({})
        this.props.changeGroupRole(role_type);
      }

      let that = this;
      let current_user = this.props.user;

      axios
        .post(url.joinGroup, payload)
        .then(({ data }) => {
          let { groups } = current_user;

          that.props.incrementMemberCount(status.value == 1 ? 1 : -1);

          if (status.value == 1) {
            groups && groups.length > 0
              ? that.props.onProfileUpdate({ groups: [insert_grp, ...groups] })
              : that.props.onProfileUpdate({ groups: [insert_grp] });
          } else {
            let result = groups.filter((e) => e.o_id != this.props.item._id);
            that.props.onProfileUpdate({ groups: result });
            that.setState({ isLeaveGroup: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  renderStyles = (checkVal) => {
    return eventDetailsCss(checkVal, this.props.mod_height);
  };

  renderEventOptions = () => {
    let { groupType, group_status,isAnonymousVisible } = this.state,
      res;




    let current_val = groupRsvp(isAnonymousVisible).filter((e) => e.value == groupType)[0];
    // let{isParentType}=this.props
    console.log(current_val,'-----groupType---', groupType)
    if (groupType == 1) {
      res = groupRsvp(isAnonymousVisible).filter((e) => e.isFeed && e.value != current_val.value);
    } else if (groupType == 0) {
      res = groupRsvp(isAnonymousVisible).filter(
        (e) => e.isDiscover && e.value != current_val.value
      );





      // if(this.state.isAnonymousVisible){
      //   res = [...res, { value: 4, action: "JoinAnonymously", label: "Join Group Anonymously", isDiscover: true },]
      // }

      
    }

    console.log(res)
    return res;
  };

  showLeaveGroupModal = () => {
    this.setState({ isArchiveModal: !this.state.isArchiveModal });
  };

  changeCurrentGroupJoinedAnonimity = (e) => {
    const val = e.target.checked;

    const groupId = this.props.item._id;

    axios
      .post(url.changeGroupAnonimity, { anonymousValue: val, groupId ,noLoader:true})
      .then(({ updated }) => {
        console.log(updated);
        if (this.props.updateDataAfterAnonymousToggle) {
          this.props.updateDataAfterAnonymousToggle();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    // let{action, role, rsvp} = this.props.item
    let {
      curr_rsvp,
      groupType,
      preventCreate,
      group_status,
      isLeaveGroup,
      isArchiveModal,
      isAnonymousVisible
    } = this.state;

    // console.log('group_status ---- ', group_status)
    return group_status && [1,4].includes(group_status.value) ? (
      this.props.isGroupList ? (
        <div className="single_group_menu_joined_group">{group_status.joined_status}</div>
      ) : this.props.item &&
        this.props.item.groupOwner &&
        this.props.item.groupOwner._id &&
        this.props.item.groupOwner._id != this.props.user.profile._id ? (
        <span>
          <div
            className={
              isMobile
                ? "single_group_menu_leave_group_mobile"
                : "single_group_menu_leave_group"
            }
            onClick={() => this.showLeaveGroupModal()}
          >
            {isMobile && <BiLogOut className="mr-1" />}
            Leave Group
            {!isMobile && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                className=""
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            )}
            {/* <span className='flaticon-trash'/>  */}
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                              <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                            </svg> */}
          </div>

          {this.props.currentGroupJoinedAnounymously && (
            <div>
              <Toggle
                className="ml-3 mt-3"
                checked={this.props.currentGroupJoinedAnounymously}
                icons={false}
                onChange={(e) => {
                  this.changeCurrentGroupJoinedAnonimity(e);
                }}
              />{" "}
              <span style={{ fontSize: "16px" }}>Joined Anonymously</span>
            </div>
          )}

          <Modal
            isOpen={isArchiveModal}
            className="single_grp_menu_leave_option dashboardArchiveModalContainer createModalContainer"
          >
            <ModalHeader
              className="dashboardHeader"
              // charCode="X"
              //   toggle={()=>this.closeActionsModal()}
            >
              <div className="dashboardModalTitle">Leave Group</div>
            </ModalHeader>
            <ModalBody className="dashboardModalBody archiveDashboardModalContent">
              {isLeaveGroup ? (
                <span>You have left the group.</span>
              ) : (
                <span>
                  You're about to leave this group. Do you wish to continue ?
                  <div
                    className="submitPrivacyContainer archiveBtnContainer"
                    style={{ padding: "10px 0px 0px 0px" }}
                  >
                    <Button
                      className={`archiveDashboardModalBtn ${
                        preventCreate ? "disabledBtn" : ""
                      }`}
                      onClick={() => this.handleJoinGroup({ value: 3 })}
                    >
                      <span className="">
                        Leave Group
                        {/* <span className="ml10 flaticon-trash"></span> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          fill="currentColor"
                          className=""
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                        </svg>
                      </span>
                    </Button>

                    <Button
                      outline
                      color="secondary"
                      className="cancelDashboardModalBtn"
                      onClick={() => this.showLeaveGroupModal()}
                    >
                      <span className="">Cancel</span>
                    </Button>
                  </div>
                </span>
              )}
            </ModalBody>
          </Modal>
        </span>
      ) : null
    ) : (
      <span>
        {/* <div>
        <Toggle  checked={this.state.joinAnonymously} icons={false} onChange={(e)=>this.setState({joinAnonymously:e.target.checked})} />  <span style={{fontSize:"16px"}}>Join Anonymously</span>
        </div> */}
       
        <Select
          className={`${
            group_status && group_status.value == 1 ? "grp_join_01" : ""
          }`}
          value={group_status}
          onChange={(r) => this.handleJoinGroup(r)}
          isClearable={false}
          data_arr={(groupRsvp(isAnonymousVisible))}
          isSearchable={false}
          options={this.renderEventOptions()}
          placeholder=""
          menuPlacement="top"
          menuShouldScrollIntoView={true}
          // components={{Option: CustomOption, SingleValue}}
          styles={this.renderStyles(true)}
        />
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    objectives: state.enterpriseObjective.objectives,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchEnterpriseObjectives: (data) =>
      dispatch(actionCreators.storeEnterpriseObjectives(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    resetObjective: () => dispatch(actionCreators.resetEnterpriseObjectives()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddToGroup);
